// export const POPUP_LAST_HOPE = {
//   name: 'last-hope-popup',
//   localStorageKey: 'last-hope-popup_showed',
//   intercomInitialMessage: 'Hello! I want to get 10% discount on my first order.',
// };

export const POPUP_BOOSTER_ORDER_DETAIL = {
  name: 'booster-order-detail',
};

export const POPUP_BOOSTER_BID_DETAIL = {
  name: 'booster-bid-detail',
};

export const POPUP_PROMOCODE_APPLIED = {
  name: 'promocode-popup',
  getParamName: 'coupon',
  cookieName: 'promocode-applied',
};

export const POPUP_MESSENGERS_ATTACH = {
  name: 'messengers-attach-popup',
  localStorageKey: 'shouldAttachMessenger',
};

export const POPUP_CONFIRM = {
  name: 'confirm-popup',
};

export const POPUP_BAN_CHAT_MESSAGE = {
  name: 'ban-chat-message',
};

export const POPUP_TIPS_ENTER_AMOUNT = {
  name: 'tips-enter-amount',
};

export const POPUP_PRO_CHAT_NAME = 'pro-popup-chat';

export const POPUP_PRO_DETAILS_NAME = 'pro-popup-details';
